import { render, staticRenderFns } from "./SampleTestQuestion.vue?vue&type=template&id=bf96fac2&"
import script from "./SampleTestQuestion.vue?vue&type=script&lang=js&"
export * from "./SampleTestQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports